angular.module('taric.measure.report', ['taric.model.measureReport', 'common.filter.commoditycode', 'common.model.measuretype', 'taric.auth.model'])
    .controller('MeasureReportController', function (CONSTANTS, $translatePartialLoader, MeasureReportModel, MeasureTypeModel, AuthorizeModel, CommonHelper, measureTypes, countries, $state, $stateParams, $rootScope, $scope, $filter, $timeout, $translate, $location, $uibModal) {
        var measureReportCtrl = this;

        measureReportCtrl.init = function () {
            measureReportCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            measureReportCtrl.dateFormat = CONSTANTS.dateFormat;
            measureReportCtrl.altInputDateFormats = CommonHelper.getAltInputDateFormats();
            measureReportCtrl.installationCountry = CONSTANTS.installationCountry;
            measureReportCtrl.searchCriteria = MeasureReportModel.getSearchCriteria();
            measureReportCtrl.searchResult = MeasureReportModel.getSearchResult();
            measureReportCtrl.measureTypes = measureTypes;
            measureReportCtrl.controlCountry = {};
            MeasureReportModel.loggedIn = AuthorizeModel.loggedIn;

            // get valid CountryCode
            if (countries){
                measureReportCtrl.searchCriteria.country = CommonHelper.getValidSelectedItem(
                    countries.items,
                    measureReportCtrl.searchCriteria.country,
                    null);
            }

            // get valid MeasureType
            if (measureTypes) {
                measureReportCtrl.searchCriteria.measureType = CommonHelper.getValidSelectedItem(
                    measureTypes.items,
                    measureReportCtrl.searchCriteria.measureType,
                    null);
            }

            if (measureReportCtrl.isExternalLink() && measureReportCtrl.validateExternalParameters()) {
                // Auto-search to support bookmark when there are required parameters, and all parameters are valid.
                measureReportCtrl.loadDataFromServerWithoutValidation(1);
            }
        };

        measureReportCtrl.isExternalLink = function(){
            // Verify 'frm' parameter to avoid auto-search after looking up commodity code, additional code, footnote, or certificate.
            return (!$stateParams.frm || $stateParams.frm !== 'ccLookup' || $stateParams.frm !== 'adcoLookup' ||
                $stateParams.frm !== 'footnoteLookup' || $stateParams.frm !== 'certificateLookup' || $stateParams.frm !== 'ccView') &&
                $stateParams.ds && $stateParams.ccs && $stateParams.d && $stateParams.l &&
                ($stateParams.mt || $stateParams.ad || $stateParams.fn || $stateParams.ce);
        };

        // Check whether the external parameters are valid or not
        measureReportCtrl.validateExternalParameters = function(){
            return measureReportCtrl.validateSearchForm();
        };

        // Lookup and popup handling
        measureReportCtrl.openStartDatePicker = function ($event) {
            measureReportCtrl.isStartDatePickerOpen = true;
        };
        measureReportCtrl.openEndDatePicker = function ($event) {
            measureReportCtrl.isEndDatePickerOpen = true;
        };

        measureReportCtrl.selectCommodityCodeRangeStart = function(commodityCode){
            measureReportCtrl.selectCommodityCode(commodityCode, measureReportCtrl.searchCriteria.direction, "lookup", "commodityCodeRangeStart");
        };

        measureReportCtrl.selectCommodityCodeRangeEnd = function(commodityCode){
            measureReportCtrl.selectCommodityCode(commodityCode, measureReportCtrl.searchCriteria.direction, "lookup", "commodityCodeRangeEnd");
        };

        measureReportCtrl.selectCommodityCode = function (commodityCode, tradeDirection, type, ccField) {
            $state.go('taric.nomenclature.sbn', {
                cc: CommonHelper.removeSpaceCharacters(commodityCode),
                sd: CommonHelper.getBookmarkDateString(measureReportCtrl.searchCriteria.startDate),
                d: tradeDirection === '0' ? 'I' : (tradeDirection === '1' ? 'E' : tradeDirection),
                frm: 'taric.report.measure',
                type: type,
                ccField: ccField
            });
        };

        measureReportCtrl.lookupAdditionalCode = function(additionalCode){
            $state.go('taric.adco.lookup', {
                frm: 'taric.report.measure',
                sd: CommonHelper.getBookmarkDateString(measureReportCtrl.searchCriteria.startDate),
                ad: CommonHelper.removeSpaceCharacters(additionalCode),
                mo: false
            });
        };

        measureReportCtrl.lookupFootnote = function(footnote){
            $state.go('taric.footnote.lookup', {
                frm: 'taric.report.measure',
                sd: CommonHelper.getBookmarkDateString(measureReportCtrl.searchCriteria.startDate),
                fo: CommonHelper.removeSpaceCharacters(footnote)
            });
        };

        measureReportCtrl.lookupCertificate = function(certificate){
            $state.go('taric.certificate.lookup', {
                frm: 'taric.report.measure',
                sd: CommonHelper.getBookmarkDateString(measureReportCtrl.searchCriteria.startDate),
                ce: CommonHelper.removeSpaceCharacters(certificate)
            });
        };

        measureReportCtrl.openMeasurePopup = function (size, measure) {
            var additionalCodes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.additionalCodes, measureReportCtrl.searchCriteria.additionalCode);
            var preferenceCodesForMeasureOnly = false;
            var selectedPreferenceCode = null;
            var inputOrigin = measure.geographicalArea.id;
            // When measureType tradeDirection is '2' (both Import and Export), use Import as default value
            var tradeDirection = measure.measureType.tradeDirection === '0' ? 'I' : (measure.measureType.tradeDirection === '1' ? 'E' : 'I');
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/measure/measure-popup.tmpl.html',
                controller: 'MeasurePopupController as measurePopupCtrl',
                size: size,
                resolve: {
                    measureExtendedInfo: function (MeasurePopupModel) {
                        return MeasurePopupModel.getMeasureExtendedInfoForMeasureType(measure.sid, preferenceCodesForMeasureOnly, measure.commodityCode,
                            measureReportCtrl.searchCriteria.country, tradeDirection, selectedPreferenceCode, additionalCodes, measureReportCtrl.searchCriteria.startDate, null, measure.unreleased);
                    }
                }
            });
        };

        measureReportCtrl.openOriginPopup = function (size, origin) {
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/geo-area/geoarea-popup.tmpl.html',
                controller: 'GeographicalAreaPopupController as geoAreaPopupCtrl',
                size: size,
                resolve: {
                    geoAreaMemberships: function (GeographicalAreaModel) {
                        return GeographicalAreaModel.queryMembershipByGroupId(origin, measureReportCtrl.searchCriteria.startDate);
                    },
                    origin: function () {
                        return origin;
                    }
                }
            });
        };

        measureReportCtrl.openFootnotePopup = function (size, footnoteId) {
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
                controller: 'FootnotePopupController as footnotePopupCtrl',
                size: size,
                resolve: {
                    footnote: function (FootnotePopupModel) {
                        return FootnotePopupModel.findFootnote(footnoteId, measureReportCtrl.searchCriteria.startDate);
                    }
                }
            });
        };

        measureReportCtrl.openAdditionalCodePopup = function (size, additionalCodeId, commodityCode) {
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/additional-code/additional-code-popup.tmpl.html',
                controller: 'AdditionalCodePopupController as additionalCodePopupCtrl',
                size: size,
                resolve: {
                    additionalCode: function (AdditionalCodePopupModel) {
                        return AdditionalCodePopupModel.findAdditionalCode(additionalCodeId, measureReportCtrl.searchCriteria.startDate, commodityCode);
                    },
                    simulationDate: function () {
                        return measureReportCtrl.searchCriteria.startDate;
                    }
                }
            });
        };

        measureReportCtrl.openQuotaPopup = function (size, measure) {
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/quota/quota-popup.tmpl.html',
                controller: 'ViewTaricQuotaController as viewTaricQuotaCtrl',
                size: size,
                resolve: {
                    quotaDefinitionExtendedInfo: function (TaricQuotaSearchModel) {
                        var inputOrigin = measure.geographicalArea.id;
                        if (measureReportCtrl.searchCriteria.country !== "" && measureReportCtrl.searchCriteria.country) {
                            inputOrigin = measureReportCtrl.searchCriteria.country;
                        }

                        var quotaExtendedInfo = TaricQuotaSearchModel.getQuotaDefinitionExtendedInfo(measure.orderNumber, inputOrigin, measureReportCtrl.searchCriteria.startDate).then(function (quotaExtendedInfo) {
                            return quotaExtendedInfo;
                        }, function (error) {
                            measureReportCtrl.errorCode = error.data.code;
                            measureReportCtrl.errorParams = error.data.params;
                            measureReportCtrl.errorType = error.data.type;
                            return;
                        });

                        return quotaExtendedInfo;
                    },
                    simulationDate: function () {
                        return measureReportCtrl.searchCriteria.startDate;
                    },
                    showCancelButton: function () {
                        return false;
                    },
                    country: function (){
                        return measureReportCtrl.searchCriteria.country;
                    }
                }
            });
        };

        // Reset error when user changes the additional code field
        measureReportCtrl.onChangeAdditionalCode = function(){
            measureReportCtrl.searchCriteria.additionalCode = measureReportCtrl.searchCriteria.additionalCode.toUpperCase();
            measureReportCtrl.handleError();
        };
        measureReportCtrl.onChangeFootnote = function(){
            measureReportCtrl.searchCriteria.footnote = measureReportCtrl.searchCriteria.footnote.toUpperCase();
            measureReportCtrl.handleError();
        };
        measureReportCtrl.onChangeCertificate = function(){
            measureReportCtrl.searchCriteria.certificate = measureReportCtrl.searchCriteria.certificate.toUpperCase();
            measureReportCtrl.handleError();
        };

        measureReportCtrl.onChangeCountry = function(country) {
            measureReportCtrl.searchCriteria.country = country;
        };

        // Add a measure type to the search list of measure types
        measureReportCtrl.addMeasureType = function (measureType) {
            if (!measureReportCtrl.validateAddingMeasureType(measureType)){
                return;
            }

            measureReportCtrl.searchCriteria.measureTypes.push(measureType);
            measureReportCtrl.searchCriteria.measureType = null;
        };

        // Remove a the given measure type from the list
        measureReportCtrl.removeMeasureType = function (measureType) {
            measureReportCtrl.handleError();
            measureReportCtrl.searchCriteria.measureTypes = array.without(measureReportCtrl.searchCriteria.measureTypes, measureType);
        };

        // Validate measure type before adding
        measureReportCtrl.validateAddingMeasureType = function (measureType) {
            var result = true;
            measureType = CommonHelper.removeSpaceCharacters(measureType);
            if (measureType === ""){
                measureReportCtrl.errorCode = "i8n.common.error.measureType.empty";
                result = false;
            } else if (measureReportCtrl.searchCriteria.measureTypes.indexOf(measureType) > -1) {
                measureReportCtrl.errorCode = "i8n.common.error.measureType.exists";
                result = false;
            }
            return result;
        };
        
        // Add an additional code to the search list of additional codes
        measureReportCtrl.addAdditionalCode = function (adco) {
            if (!measureReportCtrl.validateAddingAdditionalCode(adco)){
                return;
            }

            measureReportCtrl.searchCriteria.additionalCodes.push(adco);
            measureReportCtrl.searchCriteria.additionalCode = null;
        };

        // Remove a the given additional code from the list
        measureReportCtrl.removeAdditionalCode = function (adco) {
            measureReportCtrl.handleError();
            measureReportCtrl.searchCriteria.additionalCodes = array.without(measureReportCtrl.searchCriteria.additionalCodes, adco);
        };

        // Validate additional code before adding
        measureReportCtrl.validateAddingAdditionalCode = function (adco) {
            var result = true;
            adco = CommonHelper.removeSpaceCharacters(adco);
            if (adco === ""){
                measureReportCtrl.errorCode = "i8n.common.error.additionalCode.empty";
                result = false;
            } else if ( measureReportCtrl.searchCriteria.additionalCodes.indexOf(adco) > -1) {
                measureReportCtrl.errorCode = "i8n.common.error.additionalCode.exists";
                result = false;
            }
            return result;
        };

        // Check for additional codes to be used in the query parameters
        measureReportCtrl.validateAdditionalCodes = function() {
            var additionalCodes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.additionalCodes,
                measureReportCtrl.searchCriteria.additionalCode);

            for (let i = 0; i < additionalCodes.length; i++){
                measureReportCtrl.errorCode = CommonHelper.validateAdditionalCode(additionalCodes[i]);
                if (measureReportCtrl.errorCode) {
                    return false;
                }
            }
            return true;
        };

        // Add a footnote to the search list of footnotes
        measureReportCtrl.addFootnote = function(footnote) {
            if (!measureReportCtrl.validateAddingFootnote(footnote)){
                return;
            }

            measureReportCtrl.searchCriteria.footnotes.push(footnote);
            measureReportCtrl.searchCriteria.footnote = null;
        };

        // Remove a the given footnote from the list
        measureReportCtrl.removeFootnote = function(footnote) {
            measureReportCtrl.handleError();
            measureReportCtrl.searchCriteria.footnotes = array.without(measureReportCtrl.searchCriteria.footnotes, footnote);
        };

        // Validate footnote before adding
        measureReportCtrl.validateAddingFootnote = function(footnote) {
            var result = true;
            footnote = CommonHelper.removeSpaceCharacters(footnote);
            if (footnote === ""){
                measureReportCtrl.errorCode = "i8n.common.error.footnote.empty";
                result = false;
            } else if (measureReportCtrl.searchCriteria.footnotes.indexOf(footnote) > -1) {
                measureReportCtrl.errorCode = "i8n.common.error.footnote.exists";
                result = false;
            }
            return result;
        };

        // Check for footnotes to be used in the query parameters
        measureReportCtrl.validateFootnotes = function() {
            var footnotes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.footnotes,
                measureReportCtrl.searchCriteria.footnote);

            for (let i = 0; i < footnotes.length; i++){
                measureReportCtrl.errorCode = CommonHelper.validateFootnote(footnotes[i]);
                if (measureReportCtrl.errorCode) {
                    return false;
                }
            }
            return true;
        };

        // Add a certificate to the search list of certificates
        measureReportCtrl.addCertificate = function (certificate) {
            if (!measureReportCtrl.validateAddingCertificate(certificate)){
                return;
            }

            measureReportCtrl.searchCriteria.certificates.push(certificate);
            measureReportCtrl.searchCriteria.certificate = null;
        };

        // Remove a the given certificate from the list
        measureReportCtrl.removeCertificate = function (certificate) {
            measureReportCtrl.handleError();
            measureReportCtrl.searchCriteria.certificates = array.without(measureReportCtrl.searchCriteria.certificates, certificate);
        };

        // Validate certificate before adding
        measureReportCtrl.validateAddingCertificate = function (certificate) {
            var result = true;
            certificate = CommonHelper.removeSpaceCharacters(certificate);
            if (certificate === ""){
                measureReportCtrl.errorCode = "i8n.common.error.certificate.empty";
                result = false;
            } else if (measureReportCtrl.searchCriteria.certificates.indexOf(certificate) > -1) {
                measureReportCtrl.errorCode = "i8n.common.error.certificate.exists";
                result = false;
            }
            return result;
        };

        // Check for certificates to be used in the query parameters
        measureReportCtrl.validateCertificates = function() {
            var certificates = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.certificates,
                measureReportCtrl.searchCriteria.certificate);

            for (let i = 0; i < certificates.length; i++){
                measureReportCtrl.errorCode = CommonHelper.validateCertificate(certificates[i]);
                if (measureReportCtrl.errorCode) {
                    return false;
                }
            }
            return true;
        };

        measureReportCtrl.search = function () {
            // Load data for the first page
            measureReportCtrl.loadDataFromServer(1);
        };

        //Load data for a given page
        measureReportCtrl.loadDataFromServer = function(page){
            if (!measureReportCtrl.validateSearchForm()){
                return;
            }

            measureReportCtrl.loadDataFromServerWithoutValidation(page);
        };

        //Load data for a given page without validation
        measureReportCtrl.loadDataFromServerWithoutValidation = function(page){
            // Reset search result before searching
            measureReportCtrl.resetSearchResult();
            measureReportCtrl.searching = true;

            MeasureReportModel.searchMeasureReport(page).then(function(searchResult) {
                measureReportCtrl.searchResult = searchResult;
                measureReportCtrl.searching = false;
                measureReportCtrl.updateBrowserURL();
            }, function(error){
                measureReportCtrl.errorCode = error.data.code;
                measureReportCtrl.errorParams = error.data.params;
                measureReportCtrl.errorType = error.data.type;
                measureReportCtrl.searching = false;

                if (measureReportCtrl.errorCode === 'i8n.bl.unauthenticated') {
                    $rootScope.$broadcast('tokenInvalid');
                }
            });
        };

        /**
         * Measure report
         * {Protocol}://{HostName}:{PortNumber}/{TariffWebContext}/taric/report/measure?ds={StartDate}&de={EndDate}
         * &ccs={CommodityCodeRangeStart}&cce={CommodityCodeRangeEnd}&d={TradeDirection}&co={Country}
         * &mt={MeasureTypes}&ad={AdditionalCodes}&fn={Footnotes}&ce={Certificates}
         * &gnd={GoodsNomenclatureDescription}&add={AdditionalCodeDescription}&fnd={FootnoteDescription}
         * &ced={CertificateDescription}&gad={GeographicalAreaDescription}&ded={DutyExpressionDescription}&l={Language}
         *
         * Example:
         * http://localhost:8080/arctictariff-public-web/#!/taric/report/measure?ds=2017-01-01&de=2017-12-31
         * &ccs=01&cce=99&d=I&co=US&mt=552,554&ad=A940&fn=CD698,CD699&ce=D008
         * &gnd=true&add=true&fnd=true&ced=true&gad=true&ded=true&l=en
         */
        measureReportCtrl.updateBrowserURL = function(){
            if (!CONSTANTS.enableBookmark){
                return;
            }

            // Do not keep additional parameter 'frm' because there is no return to caller page
            $location.search({
                ds: CommonHelper.getBookmarkDateString(measureReportCtrl.searchCriteria.startDate),
                de: CommonHelper.getBookmarkDateString(measureReportCtrl.searchCriteria.endDate),
                ccs: CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.commodityCodeRangeStart),
                cce: CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.commodityCodeRangeEnd),
                d: measureReportCtrl.searchCriteria.direction,
                co: measureReportCtrl.searchCriteria.country,
                mt: CommonHelper.getDistinctCodesString(measureReportCtrl.searchCriteria.measureTypes, measureReportCtrl.searchCriteria.measureType),
                ad: CommonHelper.getDistinctCodesString(measureReportCtrl.searchCriteria.additionalCodes, measureReportCtrl.searchCriteria.additionalCode),
                fn: CommonHelper.getDistinctCodesString(measureReportCtrl.searchCriteria.footnotes, measureReportCtrl.searchCriteria.footnote),
                ce: CommonHelper.getDistinctCodesString(measureReportCtrl.searchCriteria.certificates, measureReportCtrl.searchCriteria.certificate),
                gnd: measureReportCtrl.searchCriteria.goodsNomenclatureDescription.toString(),
                add: measureReportCtrl.searchCriteria.additionalCodeDescription.toString(),
                fnd: measureReportCtrl.searchCriteria.footnoteDescription.toString(),
                ced: measureReportCtrl.searchCriteria.certificateDescription.toString(),
                gad: measureReportCtrl.searchCriteria.geographicalAreaDescription.toString(),
                ded: measureReportCtrl.searchCriteria.dutyExpressionDescription.toString(),
                l : $translate.use()
            }).replace();
        };

        measureReportCtrl.resetSearchResult = function() {
            measureReportCtrl.searchResult = null;
        };

        measureReportCtrl.validateSearchForm = function(){
            measureReportCtrl.handleError();

            // Validate dates
            measureReportCtrl.errorCode = CommonHelper.validateSimulationDate(measureReportCtrl.searchCriteria.startDate);
            if (measureReportCtrl.errorCode) {
                measureReportCtrl.errorParams = {param0: CONSTANTS.pastDate};
                return false;
            }
            // Start date must be before or the same as end date
            if (CommonHelper.compareDatesWithoutTime(measureReportCtrl.searchCriteria.startDate, measureReportCtrl.searchCriteria.endDate) > 0){
                measureReportCtrl.errorCode = "i8n.common.invalidPeriod";
                return false;
            }

            // Validate commodity codes
            if (!measureReportCtrl.searchCriteria.commodityCodeRangeStart){
                measureReportCtrl.errorCode = 'i8n.error.commodity.commodityCode.required';
                return false;
            }
            
            var ccRangeStart = CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.commodityCodeRangeStart);
            var ccRangeEnd = CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.commodityCodeRangeEnd);
            if (ccRangeStart !== "" && ccRangeEnd !== "" && ccRangeStart.localeCompare(ccRangeEnd) > 0){
                measureReportCtrl.errorCode = "i8n.qry.report.measure.search.commodityCodeRange.incorrect";
                return false;
            }
            measureReportCtrl.errorCode = CommonHelper.validateCommodityCode(measureReportCtrl.searchCriteria.commodityCodeRangeStart, measureReportCtrl.searchCriteria.direction);
            if (measureReportCtrl.errorCode){
                return false;
            }
            measureReportCtrl.errorCode = CommonHelper.validateCommodityCode(measureReportCtrl.searchCriteria.commodityCodeRangeEnd, measureReportCtrl.searchCriteria.direction);
            if (measureReportCtrl.errorCode){
                return false;
            }

            // The user must provide at least one of measure type, additional code, certificate or footnote
            if (CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.measureType) === "" &&
                    CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.additionalCode) === "" &&
                    CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.footnote) === "" &&
                    CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.certificate) === "" &&
                    measureReportCtrl.searchCriteria.measureTypes.length === 0 &&
                    measureReportCtrl.searchCriteria.additionalCodes.length === 0 &&
                    measureReportCtrl.searchCriteria.footnotes.length === 0 &&
                    measureReportCtrl.searchCriteria.certificates.length === 0) {

                measureReportCtrl.errorCode = 'i8n.qry.report.measure.search.requiredCriteria';
                return false;
            }

            // Validate additional codes
            if (!measureReportCtrl.validateAdditionalCodes()){
                return false;
            }

            // Validate footnotes
            if (!measureReportCtrl.validateFootnotes()){
                return false;
            }

            // Validate certificates
            if (!measureReportCtrl.validateCertificates()){
                return false;
            }

            // ACSMNT-3924 If the input code is the same as one that has already been added, set the input code to empty
            var code = CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.measureType);
            if (code && measureReportCtrl.searchCriteria.measureTypes.indexOf(code) > -1) {
                measureReportCtrl.searchCriteria.measureType = null;
            }

            code = CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.additionalCode);
            if (code && measureReportCtrl.searchCriteria.additionalCodes.indexOf(code) > -1) {
                measureReportCtrl.searchCriteria.additionalCode = null;
            }

            code = CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.footnote);
            if (code && measureReportCtrl.searchCriteria.footnotes.indexOf(code) > -1) {
                measureReportCtrl.searchCriteria.footnote = null;
            }

            code = CommonHelper.removeSpaceCharacters(measureReportCtrl.searchCriteria.certificate);
            if (code && measureReportCtrl.searchCriteria.certificates.indexOf(code) > -1) {
                measureReportCtrl.searchCriteria.certificate = null;
            }
            
            return true;
        };

        //Handle page change for the measure search result table
        measureReportCtrl.searchResultPageChanged = function(page){
            measureReportCtrl.loadDataFromServer(page);
        };

        measureReportCtrl.handleError = function(error) {
            if (!error) {
                measureReportCtrl.errorCode = null;
                measureReportCtrl.errorParams = null;
                measureReportCtrl.errorType = null;
            } else {
                measureReportCtrl.errorCode = error.errorCode;
                measureReportCtrl.errorParams = error.errorParams;
                measureReportCtrl.errorType = error.errorType;
            }
        };

        measureReportCtrl.onStartDateChange = function (dateString) {
            measureReportCtrl.searchCriteria.startDate = CommonHelper.formatDate(measureReportCtrl.searchCriteria.startDate, dateString);
            measureReportCtrl.handleError();
            measureReportCtrl.reloadCountries();
            measureReportCtrl.reloadMeasureTypes();
        };

        measureReportCtrl.onEndDateChange = function (dateString) {
            measureReportCtrl.searchCriteria.endDate = CommonHelper.formatDate(measureReportCtrl.searchCriteria.endDate, dateString);
            measureReportCtrl.handleError();
            measureReportCtrl.reloadMeasureTypes();
        };

        measureReportCtrl.reloadCountries = function () {
            if (!measureReportCtrl.searchCriteria.startDate ||
                CommonHelper.compareDatesWithoutTime(measureReportCtrl.searchCriteria.startDate, measureReportCtrl.searchCriteria.endDate) > 0) {
                return;
            }

            measureReportCtrl.loadingReferenceData = true;
            measureReportCtrl.controlCountry.reload(measureReportCtrl.searchCriteria.startDate).then(() => {
                measureReportCtrl.loadingReferenceData = false;
            }, function (error) {
                measureReportCtrl.errorCode = error.data.code;
                measureReportCtrl.errorParams = error.data.params;
                measureReportCtrl.errorType = error.data.type;
                measureReportCtrl.loadingReferenceData = false;
            });
        };

        measureReportCtrl.reloadMeasureTypes = function () {
            if (!measureReportCtrl.searchCriteria.startDate ||
                    CommonHelper.compareDatesWithoutTime(measureReportCtrl.searchCriteria.startDate, measureReportCtrl.searchCriteria.endDate) > 0) {
                return;
            }

            MeasureTypeModel.getMeasureTypes(measureReportCtrl.searchCriteria.direction,
                                             measureReportCtrl.searchCriteria.startDate,
                                             measureReportCtrl.searchCriteria.endDate).then(function (measureTypes) {
                measureReportCtrl.measureTypes = measureTypes;
                measureReportCtrl.searchCriteria.measureType = CommonHelper.getValidSelectedItem(
                    measureTypes.items,
                    measureReportCtrl.searchCriteria.measureType,
                    null);
            });
        };

        measureReportCtrl.hasNationalMeasureTypes = function(){
            var nationalMeasureTypes = measureReportCtrl.measureTypes.items.filter(function(measureType){
                return measureType.national === true;
            });
            return nationalMeasureTypes.length > 0;
        };
        
        // export pdf
        measureReportCtrl.print = function(options){
            if (!measureReportCtrl.validateSearchForm()){
                $scope.$apply();
                return;
            }

            $rootScope.$broadcast('startSpinningPrint');

            // Get temporary code list to add Search criteria in PDF export
            measureReportCtrl.searchCriteria.queryMeasureTypes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.measureTypes, measureReportCtrl.searchCriteria.measureType);
            measureReportCtrl.searchCriteria.queryAdditionalCodes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.additionalCodes, measureReportCtrl.searchCriteria.additionalCode);
            measureReportCtrl.searchCriteria.queryFootnotes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.footnotes, measureReportCtrl.searchCriteria.footnote);
            measureReportCtrl.searchCriteria.queryCertificates = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.certificates, measureReportCtrl.searchCriteria.certificate);

            MeasureReportModel.searchMeasureReport(null, 'pdf').then(function (searchResult) {

                measureReportCtrl.searchAllResult = searchResult;
                setTimeout(function(){

                    // load documents
                    var doc = [];
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportFormTable'), options);
                    doc.push ({ text: '\n' });
                    CommonHelper.htmlTableToPdf(doc, document.getElementById('exportResultTable'), options);
                    if (measureReportCtrl.searchAllResult.goodsNomenclatures) {
                        doc.push ({ text: '\n' });
                        CommonHelper.htmlTableToPdf(doc, document.getElementById('goodsNomenclatures'), options);
                    }
                    if (measureReportCtrl.searchAllResult.additionalCodes) {
                        doc.push ({ text: '\n' });
                        CommonHelper.htmlTableToPdf(doc, document.getElementById('additionalCodes'), options);
                    }
                    if (measureReportCtrl.searchAllResult.footnotes) {
                        doc.push ({ text: '\n' });
                        CommonHelper.htmlTableToPdf(doc, document.getElementById('footnotes'), options);
                    }
                    if (measureReportCtrl.searchAllResult.certificates) {
                        doc.push ({ text: '\n' });
                        CommonHelper.htmlTableToPdf(doc, document.getElementById('certificates'), options);
                    }
                    if (measureReportCtrl.searchAllResult.geographicalAreas) {
                        doc.push ({ text: '\n' });
                        CommonHelper.htmlTableToPdf(doc, document.getElementById('geographicalAreas'), options);
                    }

                    CommonHelper.printPlainDocument({
                        contents: doc,
                        logo: options.logo,
                        flag: measureReportCtrl.flagImg,
                        eu: measureReportCtrl.euImg,
                        validDate: $filter('date')(measureReportCtrl.searchCriteria.startDate, CONSTANTS.dateFormat),
                        title: $filter('translate')('i8n.qry.report.measure.title')
                    }, 'l').then(() => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    }, (error) => {
                        $rootScope.$broadcast('stopSpinningPrint');
                    });
                }, 1000);
            }, function (error) {

                measureReportCtrl.errorCode = error.data.code;
                measureReportCtrl.errorParams = error.data.params;
                measureReportCtrl.errorType = error.data.type;
                $rootScope.$broadcast('stopSpinningPrint');

                if (measureReportCtrl.errorCode === 'i8n.bl.unauthenticated') {
                    $rootScope.$broadcast('tokenInvalid');
                }
            });
        };
        
    	$scope.$on('printDocument', function(event, data) {
            CommonHelper.loadImage("img/flags/EU.png", 21, 14, function(options) {

                measureReportCtrl.euImg = options.logo;
            }, true);

            var url = "img/flags/" + measureReportCtrl.installationCountry + ".png";
            CommonHelper.loadImage(url, 21, 14, function(options) {

                measureReportCtrl.flagImg = options.logo;
                CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, measureReportCtrl.print, true);
            }, true);
        });

        // export excel
        measureReportCtrl.exportExcel = function() {
            if (!measureReportCtrl.validateSearchForm()){
                $scope.$apply();
                return;
            }

            $rootScope.$broadcast('startSpinningExport');

            // Get temporary code list to add Search criteria in XLS export
            measureReportCtrl.searchCriteria.queryMeasureTypes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.measureTypes, measureReportCtrl.searchCriteria.measureType);
            measureReportCtrl.searchCriteria.queryAdditionalCodes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.additionalCodes, measureReportCtrl.searchCriteria.additionalCode);
            measureReportCtrl.searchCriteria.queryFootnotes = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.footnotes, measureReportCtrl.searchCriteria.footnote);
            measureReportCtrl.searchCriteria.queryCertificates = CommonHelper.getDistinctCodeList(measureReportCtrl.searchCriteria.certificates, measureReportCtrl.searchCriteria.certificate);

            MeasureReportModel.searchMeasureReport(null, 'excel').then(function (searchResult) {

                measureReportCtrl.searchAllResult = searchResult;
                setTimeout(function(){

                    var title = $filter('translate')('i8n.qry.report.measure.title');

                    // columns format of excel
                    var exportExcelTableId = "exportExcelTable";
                    var ws = {
                        '!cols': [{
                            wpx: 50
                        }, {
                            wpx: 100
                        }, {
                            wpx: 80
                        }, {
                            wpx: 100
                        }, {
                            wpx: 110
                        }, {
                            wpx: 250
                        }, {
                            wpx: 100
                        }, {
                            wpx: 90
                        }, {
                            wpx: 80
                        }, {
                            wpx: 80
                        }, {
                            wpx: 80
                        }, {
                            wpx: 80
                        }, {
                            wpx: 80
                        }]
                    };

                    if (!measureReportCtrl.searchCriteria.dutyExpressionDescription) {
                        exportExcelTableId = "exportExcelTableWithoutDutyExpression";
                        ws = {
                            '!cols': [{
                                wpx: 50
                            }, {
                                wpx: 100
                            }, {
                                wpx: 80
                            }, {
                                wpx: 100
                            }, {
                                wpx: 110
                            }, {
                                wpx: 100
                            }, {
                                wpx: 90
                            }, {
                                wpx: 80
                            }, {
                                wpx: 80
                            }, {
                                wpx: 80
                            }, {
                                wpx: 80
                            }, {
                                wpx: 80
                            }]
                        };
                    }

                    // export excel
                    CommonHelper.printExcel(exportExcelTableId, title, ws).then(() => {
                        $rootScope.$broadcast('stopSpinningExport');
                    }, () => {
                        $rootScope.$broadcast('stopSpinningExport');
                    });
                }, 1000);

            }, function (error) {

                measureReportCtrl.errorCode = error.data.code;
                measureReportCtrl.errorParams = error.data.params;
                measureReportCtrl.errorType = error.data.type;
                $rootScope.$broadcast('stopSpinningExport');

                if (measureReportCtrl.errorCode === 'i8n.bl.unauthenticated') {
                    $rootScope.$broadcast('tokenInvalid');
                }
            });
        };

        $scope.$on('exportDocument', function(event, data) {
            measureReportCtrl.exportExcel();
        });

        $rootScope.$on('$translateChangeSuccess', function () {

            //This is just a workaround to force the page to re-render the pagination items with translated texts
            measureReportCtrl.itemsPerPage = 99999999;
            $timeout(function(){
                measureReportCtrl.itemsPerPage = CONSTANTS.rowsPerPage;
            }, 100);
        });
    });


// WEBPACK FOOTER //
// ./app/taric/report/measure/measure-report-search.js